<aside class="space-y-6 lg:sticky">
  <div class="relative text-left" id="apply-button">
    <app-button
      class="w-full btn-width-auto"
      [label]="'BUTTONS.APPLY_SERVICE' | translate"
      [classesName]="
        platinumMember
          ? 'btn-edge-cut w-full btn-platinum py-3'
          : 'btn-edge-cut w-full py-3'
      "
      (onBtnClick)="applyService()"
      iconClass="fas fa-plus"
    ></app-button>
    @if (expandServicesList) {
      <div
        class="absolute right-0 z-10 w-full origin-top-right bg-white shadow-lg ring-1 ring-black/5 text-dc-navy text-sm font-semibold"
      >
        @for (group of groupsFiltered; track group; let i = $index) {
          @if (group.active) {
            <div class="border-b border-gray-300">
              <!-- Header -->
              <div
                class="w-full flex justify-between items-center px-2 py-2 bg-gray-200 cursor-pointer"
                (click)="toggleServiceGroup(group)"
              >
                <span
                  >{{ (group.parentServiceName ? group.parentServiceName :  group.groupName) | translate
                  }} ({{ group.services.length }})</span
                >
                <i
                  class="fas"
                  [ngClass]="group.isOpen ? 'fa-chevron-up' : 'fa-chevron-down'"
                ></i>
              </div>
              <!-- Dropdown List -->
              @if (group.isOpen) {
                <ul
                  class="bg-white transition-all duration-300 ease-in px-2 py-2 space-y-2"
                >
                  @for (service of group?.services; track service) {
                    @if (service.active) {
                      <li>
                        <a
                          (click)="startService(service)"
                          class="block hover:text-dc-navy"
                          [ngClass]="lang === 'ar' ? 'text-right' : 'text-left'"
                        >
                          {{ service.serviceNameTranslation | translate }}
                        </a>
                      </li>
                    }
                  }
                </ul>
              }
            </div>
          }
        }
      </div>
    }
  </div>
  <!-- Pending actions -->
  <div
    class="bg-white border p-4"
    [ngClass]="
      pendingActionsCount === 0
        ? 'rounded-xl border-[#76B82A] text-[#76B82A]'
        : 'rounded-xl border-dc-orange text-dc-orange'
    "
  >
    <div class="flex items-center justify-between">
      <div
        class="flex items-center gap-2 cursor-pointer"
        (click)="
          pendingActionsCount > 1 ? togglePendingActions() : gotoApplications()
        "
      >
        @if (pendingActionsCount === 0) {
         <img [src]="'/icons/svg/status-success.svg'" />
        } @else {
          <img [src]="'/icons/svg/pending.svg'" />
        }
        <h4>
          {{ "BG_DASH.PENDING" | translate: { count: pendingActionsCount } }}
        </h4>
      </div>
      <div class="flex items-center gap-3">
        @if (pendingActionsCount === 0) {
          <i
            class="fas fa-chevron-right transition-transform rtl:rotate-180 cursor-pointer"
          ></i>
        } @else {
          <img
            [src]="'icons/svg/arrow-right-orange.svg'"
            class="transition-transform rtl:rotate-180 cursor-pointer"
          />
        }
      </div>
    </div>
    @if (pendingActionsCount > 1 && pendingActionsExpanded) {
      <div
        class="mt-3 border-t border-dc-orange/30 pt-3 text-dc-navy max-h-48 overflow-y-auto"
        [attr.dir]="lang === 'ar' ? 'rtl' : 'ltr'"
      >
        <div class="space-y-3 text-sm">
          @for (pendingAction of pendingActions; track pendingAction) {
            <div
              class="w-full space-y-1 text-dc-navy hover:text-dc-navy/80 cursor-pointer border-b border-gray-200 pb-2 last:border-b-0"
              [ngClass]="lang === 'ar' ? 'text-right' : 'text-left'"
              (click)="openPendingAction(pendingAction)"
            >
              <div class="font-semibold">{{ pendingAction["SR Number"] }}</div>
              <div>{{ pendingAction.Status }}</div>
              <div>{{ pendingAction["Sub Type"] }}</div>
            </div>
          }
          @for (pendingCase of pendingCases; track pendingCase) {
            <div
              class="w-full space-y-1 text-dc-navy hover:text-dc-navy/80 cursor-pointer border-b border-gray-200 pb-2 last:border-b-0"
              [ngClass]="lang === 'ar' ? 'text-right' : 'text-left'"
              (click)="openPendingCase(pendingCase)"
            >
              <div class="font-semibold">
                {{'MEDIATION_LIST.COL.CASE_NUMBER' | translate}} : {{ pendingCase["Serial Number"] }}
              </div>
            </div>
          }
        </div>
      </div>
    }
  </div>

  <!-- Platinum bage -->
  @if (platinumMember && platinumMember?.isPlatinumAccount == "Yes") {
    <section
      id="notifications"
      class="manager-card border rounded-md border-dc-navy bg-gradient-to-br from-white via-white to-dc-sky-50 p-4 shadow-sm"
    >
      <div class="flex items-start justify-between">
        <img src="/images/platinum-badge.png" />
        <button (click)="togglePlatinumMemDetail()" class="">
          <img
            src="/icons/svg/angle-down.svg"
            class="transition-transform rtl:rotate-180 duration-200"
            [class.rotate-180]="isOpenPlatinumMemDetail"
            alt="toggle details"
          />
        </button>
      </div>
      <!-- company name -->
      <h3 class="mt-3 text-base font-bold text-dc-navy">
        {{ platinumMember.memberName }}
      </h3>
      <!-- collapsible body -->
      @if (isOpenPlatinumMemDetail) {
        <div class="space-y-3 pt-3 transition-all duration-200">
          <!-- src="/images/Avatar.png" -->
          <img
            [src]="'/icons/platinum/user.svg'"
            class="rounded-full object-cover ring-1 ring-dc-sky-50"
            alt="{{ platinumMember.manager }}"
          />
          <div>
            <p class="text-base! font-bold! text-dc-navy!">
              {{ platinumMember.manager }}
            </p>
            <p class="text-base! font-light! text-dc-navy!">
              <!-- {{ platinumMember.mobile }} -->
              {{ platinumMember.title }}
            </p>
            <p class="text-base! font-light! text-dc-navy!">
              {{ platinumMember.email }}
            </p>
          </div>
          <div class="flex gap-8 pt-1">
            <a
              [href]="platinumMember.emailLink"
              class="relative font-medium text-dc-link underline-offset-4 underline text-dc-navy"
            >
              {{ "BG_DASH.PLATINUM_EMAIL_NOW" | translate }}
            </a>
            <a
              class="relative font-medium text-dc-link underline-offset-4 underline text-dc-navy"
              (click)="viewPlatinumDetails()"
            >
              {{ "BG_DASH.PLATINUM_VIEW_DETAILS" | translate }}
            </a>
          </div>
        </div>
      }
    </section>
  }
  <!-- Notifications -->
  <section class="dc-collapse-card" id="notifications">
    <div class="dc-collapse-card-heading">
      <h3 [routerLink]="'/notifications'" class="cursor-pointer">
        <img [src]="getIconPath('svg/notification.svg')" alt="" class="" />
        <span>
          {{ "BG_DASH.NOTIFICATIONS" | translate }}
        </span>
      </h3>

      <span [routerLink]="'/notifications'" class="cursor-pointer">
        <img
          src="/icons/svg/angle-right.svg"
          class="transition-transform rtl:rotate-180"
        />
      </span>
    </div>

    <div class="divide-y divide-gray-200">
      @if (notificationsLoading) {
        <div class="p-4 text-dc-navy">
          <p class="text-sm text-dc-navy!">
            {{ "LOADING" | translate }}
          </p>
        </div>
      } @else if (notifications.length < 1) {
        <div class="p-4 text-dc-navy">
          <p class="text-sm text-dc-navy!">
            {{ "BG_DASH.NO_NOTIFICATIONS" | translate }}
          </p>
        </div>
      } @else {
        @for (notification of notifications; track notification.id; let i = $index) {
          <div
            class="cursor-pointer p-4 text-dc-navy"
            [ngClass]="i === 0 ? 'bg-blue-50' : 'bg-white'"
            [routerLink]="'/notifications'"
          >
            <p class="text-[1.05rem] font-semibold leading-7 text-dc-navy!">
              {{ getNotificationPreview(notification) }}
            </p>
            <p class="mt-3 text-sm text-gray-500">
              {{ getNotificationTime(notification.createdOnDate, notification.created) }}
            </p>
          </div>
        }
      }
    </div>
  </section>

  <!-- Suggested services -->
  <section
    class="dc-collapse-card suggested-services-card"
    [ngClass]="{ 'platinum-surface': isPlatinumTheme }"
  >
    <div class="dc-collapse-card-heading">
      <h3>
        <img [src]="getIconPath('svg/crown.svg')" />
        <span>
          {{ "BG_DASH.SUGGESTED" | translate: { count: 2 } }}
        </span>
      </h3>
      <span routerLink="/services">
        <img
          src="/icons/svg/angle-right.svg"
          class="transition-transform rtl:rotate-180"
        />
      </span>
    </div>
    <div class="divide-y divide-gray-200">
      @for (s of suggestedServices; track s) {
        <div class="p-4 text-dc-navy">
          <p class="font-semibold! text-dc-navy!">{{ s.title | translate }}</p>
          <p class="text-xs text-dc-navy!">{{ s.text | translate }}</p>
          <p
            class="flex gap-3 items-center font-semibold! text-dc-navy! cursor-pointer"
            (click)="startService(s)"
          >
            <span>{{ "BG_DASH.APPLY_NOW" | translate }}</span>
            <img
              src="/icons/svg/arrow-right.svg"
              class="transition-transform rtl:rotate-180"
            />
          </p>
        </div>
      }
    </div>
  </section>
</aside>
